var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.translate.result.inelegible.instruction)+" "),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.translate.result.inelegible.whatsapp)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }